<div class="flex h-screen">
  <!-- Side Menu -->
  <app-side-menu
    [collapsed]="collapsed"
    [companyName]="companyName"
    [userName]="userName"
    [avatarSrc]="avatarSrc"
    [menuFeatureItems]="menuFeatureItems"
    [menuUserItems]="menuUserItems"
    (menuItemClicked)="onMenuItemClicked($event)"
    (toggleCollapsed)="onToggleCollapsed($event)"
    logoSrc="assets/images/logo/taxtimer-logo.svg"
    logoIconSrc="assets/images/logo/taxtimer-icon.svg"
  ></app-side-menu>

  <!-- Main Content Area -->
  <div class="flex flex-1 flex-col overflow-hidden">
    <!-- Main Content -->
    <main
      cdkScrollable
      class="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100 pt-[38px] pr-8 pb-8 pl-8 max-2xl:pt-6 max-2xl:pr-6 max-2xl:pb-6 max-2xl:pl-6"
    >
      <router-outlet></router-outlet>
    </main>
  </div>
</div>

@if (loadingOverlay.visible()) {
  <div
    *transloco="let t"
    class="fixed inset-0 z-[100] flex flex-col items-center justify-center gap-5 bg-gray-100/80 backdrop-blur-sm"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <app-loader size="md" color="blue"></app-loader>
    <p class="max-w-sm px-6 text-center text-sm font-medium text-gray-800">
      {{ loadingOverlay.text() ?? t('common.loading') }}
    </p>
  </div>
}
